import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-desc-sort",
  "use": "arrow-desc-sort-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-desc-sort\">\r\n<path d=\"M4.99932 12.2139L8.17719 15.4M8.17719 15.4L11.3633 12.2139M8.17719 15.4L8.17719 -2.78537e-07\" stroke=\"currentColor\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol